<template>
  <g>
    <rect
      x="20"
      y="20"
      :fill="fillColor"
      :stroke="strokeColor"
      stroke-width="2"
      :width="tableSize.w"
      :height="tableSize.h"
      rx="3"
    />

    <!-- North -->
    <floorplan-shape-seat
      v-for="(seat, i) in tableSeats.n"
      :key="`seat_n_${i}`"
      :stroke-color="strokeColor"
      :x="20 + seat.origin"
      y="12.5"
      :overflow="seat.isOverflow"
      :occupied="seat.occupied"
      orientation="n"
    />

    <!-- East -->
    <floorplan-shape-seat
      v-for="(seat, i) in tableSeats.e"
      :key="`seat_e_${i}`"
      :stroke-color="strokeColor"
      x="12.5"
      :y="20 + seat.origin"
      :overflow="seat.isOverflow"
      :occupied="seat.occupied"
      orientation="e"
    />

    <!-- South -->
    <floorplan-shape-seat
      v-for="(seat, i) in tableSeats.s"
      :key="`seat_s_${i}`"
      :stroke-color="strokeColor"
      :x="20 + seat.origin"
      :y="tableSize.h + 40 - 12.5"
      :overflow="seat.isOverflow"
      :occupied="seat.occupied"
      orientation="s"
    />

    <!-- West -->
    <floorplan-shape-seat
      v-for="(seat, i) in tableSeats.w"
      :key="`seat_w_${i}`"
      :stroke-color="strokeColor"
      :x="tableSize.w + 40 - 12.5"
      :y="20 + seat.origin"
      :overflow="seat.isOverflow"
      :occupied="seat.occupied"
      orientation="w"
    />
  </g>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import FloorplanShapeSeat from './FloorplanShapeSeat.vue';
import { TableSeatType, ITableSize, ITableSeats } from './floorplan-types';

export default Vue.extend({
  name: 'FloorplanShapeTableRect',
  components: { FloorplanShapeSeat },
  props: {
    partySize: { type: Number, required: false, default: 0 },
    fillColor: { type: String, required: true },
    strokeColor: { type: String, required: true },
    seats: { type: Number, required: true },
    tableSize: { type: Object as PropType<ITableSize>, required: true },
    shape: { type: String as PropType<TableSeatType>, required: true },
  },
  data() { return { }; },
  computed: {
    tableSeats(): ITableSeats | null {
      let eSeatCount = 0;
      let wSeatCount = 0;

      if (this.shape === TableSeatType.HEADSEAT) {
        eSeatCount = this.seats === 2 ? 1 : Math.ceil((this.seats - 2) / 2);
        wSeatCount = this.seats - eSeatCount - 2;
      } else {
        eSeatCount = Math.ceil(this.seats / 2);
        wSeatCount = this.seats - eSeatCount;
      }

      const eSeatToDraw = Math.min(8, eSeatCount);
      const wSeatToDraw = Math.min(8, wSeatCount);
      const seatSpacing = (this.tableSize.h - (eSeatToDraw * 30)) / (eSeatToDraw + 1);
      const seatSpacingWidth = (this.tableSize.w - 30) / 2;

      const ts = {} as ITableSeats;

      let occupiedSeats = this.partySize;
      if (this.shape === TableSeatType.HEADSEAT && this.seats > 0) {
        ts.n = [{ origin: seatSpacingWidth, occupied: occupiedSeats > 0 }];
        occupiedSeats -= 1;
        if (this.seats >= 3) {
          ts.s = [{ origin: seatSpacingWidth, occupied: occupiedSeats > 0 }];
          occupiedSeats -= 1;
        }
      }

      let seatsForE = Math.ceil(occupiedSeats / 2);
      let seatsForW = occupiedSeats - seatsForE;

      ts.e = [];
      for (let i = 0; i < eSeatToDraw; i += 1) {
        ts.e.push({ origin: ((i + 1) * seatSpacing) + i * 30, occupied: seatsForE > 0 });
        ts.e[i].isOverflow = (eSeatCount > eSeatToDraw && i === 6);
        seatsForE -= 1;
      }

      ts.w = [];
      for (let i = 0; i < wSeatToDraw; i += 1) {
        ts.w.push({ origin: ((i + 1) * seatSpacing) + i * 30, occupied: seatsForW > 0 });
        ts.w[i].isOverflow = (wSeatCount > wSeatToDraw && i === 6);
        seatsForW -= 1;
      }

      return ts;
    },
  },
  watch: { },
  mounted() { },
  methods: { },
});

</script>
